export const queryKeys = {
  AGREEMENTS: 'agreements',
  GET_AGREEMENTS_LIST: 'getAgreementsList',
  GET_AGREEMENT_DETAILS: 'getAgreementDetails',
  GET_AGREEMENT_STATS: 'getAgreementStats',
  GET_AGREEMENTS: 'getAgreements',
  GET_CONTRACT_TEMPLATE: 'getContractTemplate',
  TEAM_BUDGETS: 'getTeamBudgets',
  TEAM_BUDGET_DETAILS: 'getTeamBudget',
  ORG_BUDGETS: 'getOrgBudgetsList',
  ORG_BUDGETS_SUMMARY: 'getBudgetsOverview',
  USER_PERMISSIONS: 'getUserPermissions',
  USER_PERMISSIONS_LIST: 'getUserPermissionsList',
  ELIGIBLE_ATHLETES: 'getEligibleAthletes',
  GET_AGREEMENT_ATHLETES: 'getAgreementAthletes',
  TEAM_POSITIONS: 'getTeamPositions',
  ME: 'getMe',
  ALL_TEAMS: 'getAllTeams',
  TEAM_ATHLETE_PROFILE: 'getTeamAthleteProfile',
  TAGS: 'getTags',
  AGREEMENT_PAYMENTS: 'getAgreementPayments',
  TEAM_PAYMENTS: 'getTeamPayments',
  PAYMENT_REQUEST: 'getPaymentRequest',
  TEAM_ATHLETES_LIST: 'getTeamAthletesList',
  ATHLETE_DOCUMENTS: 'getAthleteDocuments',
  RECRUITS: 'recruits',
  ATHLETE_EARNINGS: 'athlete-earnings',
  CR_ATHLETE_PROFILE: 'cr-athlete-profile',
  ATHLETE_AGREEMENTS: 'athlete-agreements',
  ATHLETE_NOTES: 'athlete-notes',
  NIL_CATEGORIES: 'nil-categories',
  THIRD_PARTY_NIL_INFLCR: 'third-party-nil-influencer',
  /** Scholarship Packages */
  SCHOLARSHIP_PACKAGES: 'getScholarshipPackages',
  AWARD_CATEGORIES: 'getAwardCategories',
  TEAM_PAYMENTS_STATS: 'getTeamPaymentsStats',
  ANNUAL_PAYMENTS: 'getAnnualPayments',
  TEAM_BUDGET_COLUMN_PREFERENCES: 'teamBudgetColumnPreferences',
  BUDGET_GROUP: 'getBudgetGroup',
  BUDGET_GROUP_TIMELINE: 'getBudgetGroupTimeline',
  PAYMENT_HISTORY: 'getTeamPaymentHistory',
  BUDGET_GROUPS_COMPACT: 'getBudgetGroupsCompact',
  AGREEMENTS_BY_CONTRACT: 'agreementsByContract',
  NOTIFICATION_SETTINGS: 'getNotificationSettings',
  GET_ACADEMIC_YEARS: 'getAcademicYears',
  PLAYER_PERSONNEL_PLAYER_SEARCH: 'searchPlayerPersonnelPlayers',
  PLAYER_PERSONNEL_PLAYER_STATS: 'getPlayerPersonnelPlayerStats',
  PLAYER_PERSONNEL_PLAYER_SEASONS: 'getPlayerPersonnelSeasons',
  AGENTS: 'getAgents',
  AGENTS_BY_ATHLETE: 'getAgentsByAthletes',
  GET_ATHLETE_CONTRACT: 'getAthleteContract',
} as const;

export const teamworksRedirectPaths = {
  TUM: '/profiles',
} as const;
